import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface Notification {
  id: number;
  name: string;
  message: string;
}
const NAMES = ['Marianna', 'Victoria', 'Sophia', 'Isabella', 'Camila', 'Valentina', 'Emma', 'Olivia', 'Daniela', 'Gabriella', 'Andrea', 'Nicole', 'Alejandra', 'Carolina', 'Natalia', 'Jessica', 'Amanda', 'Stephanie', 'Christina', 'Monica', 'Rachel', 'Ashley', 'Brianna', 'Mia', 'Luna'];
const COOKIE_ITEMS = [{
  name: "S'more",
  plural: "S'mores"
}, {
  name: 'Dubai Crunch',
  plural: 'Dubai Crunch'
}, {
  name: 'Crunchy Cookies',
  plural: 'Crunchy Cookies'
}, {
  name: 'Churro',
  plural: 'Churros'
}, {
  name: 'Double Nut',
  plural: 'Double Nut'
}, {
  name: 'Birthday Cake',
  plural: 'Birthday Cake'
}, {
  name: 'Mid Coco',
  plural: 'Mid Coco'
}, {
  name: 'Kinderella',
  plural: 'Kinderella'
}, {
  name: 'Kinder Bueno',
  plural: 'Kinder Bueno'
}, {
  name: 'Alfajor',
  plural: 'Alfajores'
}, {
  name: 'Pistachio',
  plural: 'Pistachio'
}];
function randomFrom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generateMessage(): string {
  const roll = Math.random();
  if (roll < 0.5) {
    // Single cookie, quantity 1-3
    const cookie = randomFrom(COOKIE_ITEMS);
    const qty = Math.floor(Math.random() * 3) + 1;
    if (qty === 1) {
      return `added ${cookie.name} to her cart 🍪`;
    }
    return `added ${qty} ${cookie.plural} to her cart 🍪`;
  } else {
    // Two different cookies
    const first = randomFrom(COOKIE_ITEMS);
    let second = randomFrom(COOKIE_ITEMS);
    while (second.name === first.name) {
      second = randomFrom(COOKIE_ITEMS);
    }
    return `added ${first.name} and ${second.name} to her cart 🍪`;
  }
}
export function SocialProofToast() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [counter, setCounter] = useState(0);
  const showNotification = useCallback(() => {
    const name = randomFrom(NAMES);
    const message = generateMessage();
    setNotification({
      id: counter,
      name,
      message
    });
    setCounter(c => c + 1);
    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      setNotification(null);
    }, 5000);
  }, [counter]);
  useEffect(() => {
    // Show first one after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (counter === 0) return;
    const interval = setTimeout(() => {
      showNotification();
    }, 30000);
    return () => clearTimeout(interval);
  }, [counter, showNotification]);
  return <div className="fixed bottom-36 sm:bottom-24 left-4 z-50 pointer-events-none" data-id="element-285">
      <AnimatePresence data-id="element-286">
        {notification && <motion.div key={notification.id} initial={{
        opacity: 0,
        x: -80,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -80,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="pointer-events-auto bg-white/90 backdrop-blur-xl border border-white/50 rounded-2xl shadow-glass px-4 py-3 max-w-[280px] sm:max-w-xs" data-id="element-287">
            <div className="flex items-start gap-3" data-id="element-288">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-brand-purple/10 flex items-center justify-center text-sm" data-id="element-289">
                🛒
              </div>
              <div className="min-w-0" data-id="element-290">
                <p className="text-brand-purple text-sm leading-snug" data-id="element-291">
                  <span className="font-bold" data-id="element-292">{notification.name}</span>{' '}
                  <span className="text-brand-purple/70" data-id="element-293">
                    {notification.message}
                  </span>
                </p>
                <p className="text-brand-purple/40 text-xs mt-1" data-id="element-294">Just now</p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}